import React, { Fragment } from 'react';
import { useSocketContext } from 'socketContext';

import {
  ListItemText,
  Grow,
  Popper,
  Divider,
  Typography,
  ClickAwayListener,
} from '@material-ui/core';
import {
  ExpandMore,
  VpnKeyOutlined as KeyOutlined,
  Home,
  PowerSettingsNew,
} from '@material-ui/icons';
import withStyles from '@material-ui/core/styles/withStyles';

import routesPath from 'config/routesPath';
import isEmpty from 'helpers/isEmpty';
import PaperBorder from 'components/PaperBorder';
import getInitialsName from 'helpers/getInitialsName';

import { StatusBadge } from 'components/OverviewComponents/ShareComponents/SellersTable/styles';

import * as S from './styles';

const UserProfileComponent = ({
  attributes,
  classes,
  email,
  firstName,
  handleCallCenterButton,
  handleToggleisOpened,
  history,
  isOpened,
  isOpenedAnchor,
  logout,
  updatePassword,
  username,
  userSite,
}) => {
  const { connectedStatus } = useSocketContext();

  return (
    <Fragment>
      <S.Main
        onClick={isOpened ? () => null : handleToggleisOpened}
        ref={isOpenedAnchor}
        data-test="isOpened-popup"
      >
        <S.OvalBigger>
          {getInitialsName(username || firstName)}
          <StatusBadge online={connectedStatus} />
        </S.OvalBigger>
        <ExpandMore
          aria-owns={isOpened && 'menu-appbar'}
          aria-haspopup="true"
        />
      </S.Main>
      <Popper
        open={isOpened}
        anchorEl={isOpenedAnchor.current}
        transition
        disablePortal
        placement={'bottom'}
        data-test="isOpened-popup"
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            id="menu-list-grow"
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <ClickAwayListener
              onClickAway={isOpened ? handleToggleisOpened : () => null}
            >
              <PaperBorder className={classes.rootItemisOpened}>
                <S.MainContainer>
                  <ListItemText
                    primary={
                      <Typography noWrap className={classes.nameisOpened}>
                        {firstName}
                      </Typography>
                    }
                    secondary={
                      <Typography noWrap className={classes.emailisOpened}>
                        {email}
                      </Typography>
                    }
                  />
                  <S.UserId>
                    ID: {userSite?.id || Math.trunc(attributes.usersite_id)}
                  </S.UserId>
                  {isEmpty(attributes.callcenter) && (
                    <S.ThemeButton
                      variant="outlined"
                      onClick={() => history.push(routesPath.myResellers)}
                    >
                      <Home />
                      Minhas revendas
                    </S.ThemeButton>
                  )}
                  {!isEmpty(attributes.callcenter) && (
                    <S.ThemeButton
                      variant="outlined"
                      onClick={handleCallCenterButton}
                    >
                      <Home />
                      Central de atendimento
                    </S.ThemeButton>
                  )}
                  <Divider />
                  <S.FooterContainer>
                    <S.ChangePasswordButton onClick={() => updatePassword()}>
                      <KeyOutlined className={classes.iconMargin} />
                      <Typography className={classes.iconMargin}>
                        Alterar senha
                      </Typography>
                    </S.ChangePasswordButton>
                    <S.SingOut onClick={() => logout()}>
                      <PowerSettingsNew className={classes.iconMargin} />
                      <Typography className={classes.iconMargin}>
                        Sair
                      </Typography>
                    </S.SingOut>
                  </S.FooterContainer>
                </S.MainContainer>
              </PaperBorder>
            </ClickAwayListener>
          </Grow>
        )}
      </Popper>
    </Fragment>
  );
};

export default withStyles(S.styles)(UserProfileComponent);
